export default "__VITE_ASSET__BZbpl8Vl__"